import RedeemPointsConfirmationModal from './RedeemPointsConfirmationModal';

export default RedeemPointsConfirmationModal;
